/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-history-list',
    templateUrl: './history-list.component.html',
    styleUrls: ['./history-list.component.scss'],
})
export class HistoryListComponent implements OnChanges {
    @Input() classify = false;
    @Input() listConfig;
    @Input() listData = [];
    @Output() selectSearchItem = new EventEmitter();
    @Output() removeSelectedItem = new EventEmitter();
    dataGroup: any[] = [];

    ngOnChanges(): void {
        if (this.classify) {
            this.dataGroup = this.classifyData(this.listData);
        }
    }

    search(item): void {
        this.selectSearchItem.emit(item);
    }

    cancelItem(item, $event: { stopPropagation: () => void }): void {
        $event.stopPropagation();
        this.removeSelectedItem.emit(item);
    }

    classifyData(data: any[]): any[] {
        const dataArr = [];
        data.forEach((mapItem) => {
            const res = dataArr.some((item) => {
                if (item.title === mapItem.advancedType) {
                    item.list.push(mapItem);
                    return true;
                }

                return false;
            });
            if (!res) {
                dataArr.push({ title: mapItem.advancedType || '', list: [mapItem] });
            }
        });
        return dataArr;
    }
}
